<script setup lang="ts">
import { ref } from 'vue';
import TeamLeadInvitationForm from '@/components/team/TeamLeadInvitationForm.vue';

interface PrivacyOption {
  label: string;
  value: string;
}

interface Props {
  data?: Record<string, unknown>;
  mode?: string;
  memberData?: Record<string, unknown>;
  modalView?: boolean;
}

interface Emits {
  (e: 'statusHide'): void;
}

const _props = withDefaults(defineProps<Props>(), {
  data: undefined,
  mode: '',
  memberData: undefined,
  modalView: false,
});

const emit = defineEmits<Emits>();

const privacy = ref<string>('Public');
const error = ref<string>('');

const privacyOptions: PrivacyOption[] = [
  {
    label: 'Have a <b>public</b> discussion',
    value: 'Public',
  },
  {
    label: 'Have a <b>private</b> discussion',
    value: 'Private',
  },
  {
    label: 'Offer <b>option</b> for a private discussion',
    value: 'Optional',
  },
];

function statusHide() {
  emit('statusHide');
}
</script>

<template>
  <div>
    <div v-if="error" class="uk-alert-danger" uk-alert="animation: true;" @hide="statusHide">
      <a class="uk-alert-close" uk-close></a>
      <p>{{ error }}</p>
    </div>
    <form class="uk-flex uk-flex-column">
      <TeamLeadInvitationForm
        :invitation="memberData"
        :modalView="modalView"
        customAddText="Add Invitee"
      />

      <div v-if="mode === 'lead'">
        <p><b>All OpenVetting debates are, by default, shareable unless otherwise selected.</b></p>
        <form-group v-for="option in privacyOptions" :key="option">
          <label>
            <input class="uk-radio" type="radio" v-model="privacy" :value="option.value" />
            <span class="uk-margin-small-left" v-html="option.label"></span>
          </label>
        </form-group>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.uk-alert-danger {
  animation: fade-in 0.3s ease-in-out;
}

.uk-radio {
  margin-right: 0.5rem;
}

form {
  .uk-margin-small-left {
    margin-left: 0.5rem;
  }
}
</style>
